import React from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import SettingLayout from './components/setting_layout';

const SettingIndex = () => {
    return (
        <>
            <ContainerComponent span={22} top={20} bottom={20}>
                <SettingLayout />
            </ContainerComponent>
        </>
    );
}

export default SettingIndex;